import { render, staticRenderFns } from "./EmployerSftpSetting.vue?vue&type=template&id=7443b224"
import script from "./EmployerSftpSetting.vue?vue&type=script&lang=ts"
export * from "./EmployerSftpSetting.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports